var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.viewChannel}},[(_vm.unread.length > 0)?[_c('div',{staticClass:"ic_new_msg"}),_vm._v(" "),_c('div',{staticClass:"ic ic9-channel2"},[_c('div',{staticClass:"count_new_msg"},[_vm._v(_vm._s(_vm.unreadCount))])])]:[_c('div',{staticClass:"ic ic8-channel"})]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d33d364","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/channel/components/ChannelUnreadCounterTag.vue
// module id = null
// module chunks = 